export default __webpack_public_path__ + "locales/bg/ChangeEmailDialog.json?hash=779be9300c3e6c5254ccd969f7a0d787";